import { isMarkFinished } from 'helpers/domain-specific/mark-status.helpers';
import { markersContributingMarksAndMarkItems } from 'pages/marking/helpers/marker.helpers';
import type { ManageMarkingMark } from 'services/assist-api/entities/test-instance-response-mark/types';

export function allocatedMarkerTooltip(
  allocatedMarkerIsMarker: boolean,
  markerName: string,
  isMark: boolean
): string {
  const message = allocatedMarkerIsMarker
    ? `must be ${isMark ? 'reassigned to another marker or deleted' : 'rescored or unscored'} to ` +
      `successfully deallocate ${markerName} from the response.`
    : `does not need to be reassigned from ${markerName} to proceed with deallocation.`;
  return `${isMark ? 'Mark ' : 'Mark item'} ${message}`;
}

/**
 * Returns the number of contributing marks that are finished. This is so that we can prevent
 * deallocation when contributing marks are finished. This helps avoid a situation where a completed
 * mark contains unscored mark items - this would be a violation of the validation rules of the
 * Mark Response form.
 */
export function finishedMarksOfResponseCount(
  allocatedMarkerId: number,
  marksOfResponse: ManageMarkingMark[]
): number {
  return markersContributingMarksAndMarkItems(allocatedMarkerId, marksOfResponse).filter((mark) =>
    isMarkFinished(mark.status)
  ).length;
}
